// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53575819","453":"d6c3c0f8","455":"95f27bd0","977":"a31394e6"}[chunkId] + ".chunk.js";
};